import createIcon from './createIcon';
import SettingFilledSvg from './svg/setting-filled.svg?react';

const SettingFilledIcon = createIcon(SettingFilledSvg);

export default SettingFilledIcon;
